// 列表组件需要的数据
const baseUrl = 'nature-explorer';
export const OPTHINES = {
  voteName: '2021project/q1/2021nature',
  mustSearch: 'Button',
  number: {
    mustRank: false,
  },
  listData: {
    type: 'com',
  },
  name: true,
  content: true,
  user: true,
  tickets: {
    textFirst: '赞数',
    textLast: '赞',
  },
  checkBox: false,
  hasVoteButton: {
    text: '点赞',
    textColor: '#fff',
    themeColor: '#fe4d57',
  },
  themeColor: {
    activeBgColor: '#6C9218',
    inactiveBgColor: '#4B6C1D',
  },
  tabs: [
    {
      tabName: '活动首页',
      tabPath: `/${baseUrl}/home`,
    },
    {
      tabName: '活动概况',
      tabPath: `/${baseUrl}/rules`,
    },
    {
      tabName: '相关新闻',
      tabPath: `/${baseUrl}/news`,
    },
  ],
  language: {
    // 繁体
    traditional: {
      title: { label: '作品名稱*', placeholder: '請輸入作品名稱' },
      cover: {
        label: '上傳照片（可上傳圖片1-4張），單張圖片須大於1M，小於10M）',
        btn: '開始上傳',
      },
      birthday: {
        label: '出生年月*',
        placeholder: '年/月/日',
        title: '選擇年月日',
      },
      sex: { label: '性别*', placeholder: '選擇性别' },
      flower: { label: '代言花卉*', placeholder: '請輸入代言花卉' },
      place: { label: '拍攝地（景區或公園）', placeholder: '請輸入拍攝地' },
      workTypeValue: {
        label: '參賽組別*',
        placeholder: '選擇參賽組別',
        columns: ['小學組', '中學組', '大學組'],
        title: '參賽組別',
      },
      name: { label: '姓名*', placeholder: '請輸入姓名' },
      countyValue: { label: '區/縣*', placeholder: '選擇區/縣' },
      school: { label: '就讀學校*', placeholder: '請輸入就讀學校' },
      classes: { label: '班級*', placeholder: '請輸入班級' },
      teacher: { label: '指導老師*', placeholder: '請輸入指導老師' },
      mechanism: { label: '輔導學校/機構', placeholder: '請輸入輔導學校/機構' },
      contacts: { label: '聯絡者姓名*', placeholder: '請輸入聯絡者姓名' },
      relationship: {
        label: '與參賽者關係*',
        placeholder: '請輸入與參賽者關係',
      },
      email: { label: '電子郵箱*', placeholder: '請輸入電子郵箱' },
      phone: { label: '聯絡電話*', placeholder: '請輸入聯絡電話' },
      address: { label: '通訊地址*', placeholder: '請輸入通訊地址' },
      introduction: {
        label: '創作理念或對花卉的認識感言',
        placeholder: '100字以内',
      },
    },

    // 简体
    simplified: {
      title: { label: '作品名称*', placeholder: '请输入作品名称' },
      cover: {
        label: '上传照片（可上传图片1-4张,单张图片须大于1M,小于10M）',
        btn: '开始上传',
      },
      birthday: {
        label: '出生年月*',
        placeholder: '年/月/日',
        title: '选择年月日',
      },
      sex: { label: '性别*', placeholder: '选择性别' },
      flower: { label: '代言花卉*', placeholder: '请输入代言花卉' },
      place: { label: '拍摄地（景区或公园）', placeholder: '请输入拍摄地' },
      workTypeValue: {
        label: '参赛组别*',
        placeholder: '选择参赛组别',
        columns: ['小学组', '中学组', '大学组'],
        title: '参赛组别',
      },
      name: { label: '姓名*', placeholder: '请输入姓名' },
      countyValue: { label: '区县*', placeholder: '选择区县' },
      school: { label: '就读学校*', placeholder: '请输入学校名称' },
      classes: { label: '班级*', placeholder: '请输入班级' },
      teacher: { label: '指导老师*', placeholder: '请输入指导老师' },
      mechanism: { label: '辅导学校/机构', placeholder: '请输入辅导学校/机构' },
      contacts: { label: '联络人姓名*', placeholder: '请输入联络人姓名' },
      relationship: {
        label: '与参赛者关系*',
        placeholder: '请输入与参赛者关系',
      },
      email: { label: '电子邮箱*', placeholder: '请输入电子邮箱' },
      phone: { label: '联络电话*', placeholder: '请输入联络电话' },
      address: { label: '通讯地址*', placeholder: '请输入通讯地址' },
      introduction: {
        label: '创作理念或对花卉的认识感言',
        placeholder: '100字以内',
      },
    },
  },
};
